// extracted by mini-css-extract-plugin
module.exports = {"primary":"#004B62","primaryLight":"#7daee3","secondary":"#18327f"};